module.exports = __webpack_public_path__ + "img/1-1.16487d58.png";